import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/hugony.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>Die philophischen schriften von Gottfried Wilheim Leibniz, vol. III</var><br />
		C. I. Gerhardt (ed)<br />
		pp 680-681<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 30 November 1710<br /><br />
		Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (113k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Charles Hugony (30 November 1710)</title>
            <meta name="description" content="An English translation of a LETTER TO CHARLES HUGONY by Gottfried Wilhelm Leibniz, from 30 November 1710" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO CHARLES HUGONY</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>G III p680</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;You have obliged me greatly by giving me your news and by demonstrating that mine will not be disagreeable to you. These marks of your remembrance are dear to me.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;You will be able to judge how Madam your sister and your friends are pleased with your change, especially Mr de la Croze and others who would have been delighted to see you if not a pillar of the church then at least a defender of it. But, Sir, it is not for me to speak to you about these sorts of resolutions, and I want to believe charitably that you have acted according to the movements of your conscience. I am of your opinion that a military man [should] find some time to study. It is an occupation, in which one is not always on duty. A Marshal of France (I don't know which) said that unexperienced people think that soldiers are always fighting and that husbands are always caressing their wives. You were in a good climate, where I would like to spend the winter. I would meditate better if at my ease, and my philosophical demonstrations would be better organized. My essays on the goodness of God, the freedom of man, and the origin of evil have been printed in Holland, but I did not want my name put on them.<a name="1" href="#note1"><sup>1</sup></a> The book is woven from what I said and wrote at various times to the Queen of Prussia, who enjoyed reading Mr Bayle, and in whose company the difficulties that he raises on these matters were often discussed. In the book I try to explain some of my thoughts a little informally. Some of them cannot be presented starkly, as you know, since people are liable to take them the wrong way, not in relation to religion (which is favourably treated there) but in relation to the senses. Yet I am thinking about [writing] a Latin work in which I will try to unfold my entire system. The Benedictine Father Lamy has attacked a part of it (in his book <var>De la connoissance de soi-m&#234;me</var>),<a name="2" href="#note2"><sup>2</sup></a> namely the pre-established harmony that I use to explain the correspondence between the soul and the body. I responded to him about a year ago in an issue of the <var>Journal des Savans</var> of Paris,<a name="3" href="#note3"><sup>3</sup></a> and I was sorry to have to been obliged to seek out the objections in [<b>G III 681</b>] the objections themselves. He was obliged to admit that my system is quite plausible, and he wrote (he said) so that he could fortify himself against its false brilliance.<a name="4" href="#note4"><sup>4</sup></a> I say nothing to you about my mathematical and historical works, and I hope Castres will be your summer quarters as well as your winter quarters. That is sufficient to indicate how much I am etc.<br /><br />
        P.S. If there is in your quarters or known to you some learned person, some inspired production, some good work, please oblige me by sharing it with me. I do not know if Mr de la Loubere, who was the King's Ambassador in Siam,<a name="5" href="#note5"><sup>5</sup></a> is now in Toulouse or the vicinity, for I hope that he is still alive, likewise Mr de Fermat, son of this famous jurisconsult and mathematician, himself a very able man.<a name="6" href="#note6"><sup>6</sup></a> I hold these gentlemen in very high regard, and as I imagine there are still some posthumous writings of Mr de Fermat, I would like them to be given to the public. Is there someone who works or has worked on the history of the area, after Mr Catel?<a name="7" href="#note7"><sup>7</sup></a> If you want to do me the honour of writing to me, I ask you to send your letters to a friend in Paris, who gives them to Mr de Martine, Resident of Geneva, who transmits them to me.
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Leibniz is referring here to his <var>Theodicy</var>, published in Amsterdam in 1710. The first edition did not carry his name.<br />
                <a name="note2" href="#2">2.</a> Fran&#231;ois Lamy, <var>De la connoissance de soi-m&#234;me</var> (Paris, 1699, 2ed).<br />
                <a name="note3" href="#3">3.</a> &quot;Reponse de M. Leibnitz aux Objections que l'Auteur du Livre de la Connoissance de soy-m&#234;me, a faites contre le Systeme de l'Harmonie pr&#233;-&#233;tablie&quot;, <var>Journal des savants</var> (1709), 275-81.<br />
                <a name="note4" href="#4">4.</a> See the relevant extract of Lamy's book in <var>Leibniz's New System</var>, trans. and ed. Woolhouse and Francks (Oxford: Clarendon Press, 1997), 149.<br />
                <a name="note5" href="#5">5.</a> Simon de la Loub&#232;re (1642-1729), a French diplomat who led an embassy to Siam in 1687.<br />
                <a name="note6" href="#6">6.</a> Probably a reference to Cl&#233;ment-Samuel de Fermat (1634-1697), eldest son of Pierre de Fermat (1607-1665), who was a lawyer and mathematician.<br />
                <a name="note7" href="#7">7.</a> Leibniz means the Toulouse area. He is referring to Guillaume Catel, <var>Histoire des Comtes de Tolose</var> (Toulouse, 1623).

        <br /><br /><br />

                &#169; Lloyd Strickland 2016
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
